export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/combination-provider-icon.01bbea81-eb10c3.png";